
<template>
  <div>
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title"> Xe Máy Xe Hơi </h4>
      </div>
      <div class="modal-body">
        <!-- Apartment Existing Services -->
        <div class="row mb-1 margin-down-15" v-if="apartment_vehicle_services.length > 0">
          <div class="col-md-12">
            <p class="lead">Gợi Ý: Căn Hộ Được Chọn Có Sẵn Những Phí Dịch Vụ Gửi Xe Sau:</p>
            <p class="text-green" v-for="(item, index) in apartment_vehicle_services" :key="index">
              {{item.name}} - {{item.fee_value}} / tháng
            </p>
          </div>
        </div>
        <!-- Apartment -->
        <div class="row mb-1 margin-down-15">
          <div class="col-md-3">Căn Hộ</div>
          <div class="col-md-6">
            <b-form-select
              :options="apartments"
              v-model="vehicle.apartment"
              class="form-control"
              @change="onChangeApartment"
            />
          </div>
        </div>
        <!-- Owner -->
        <div class="row mb-1 margin-down-15">
          <div class="col-md-3">Chủ Xe</div>
          <div class="col-md-6">
            <b-form-select
              :options="customers"
              v-model="vehicle.vehicle_owner"
              class="form-control"
            />
          </div>
        </div>
        <!-- Registration Name -->
        <div class="row mb-1 margin-down-15">
          <div class="col-md-3">Tên Người Đang Ký</div>
          <div class="col-md-6">
            <input v-model="vehicle.vehicle_registration_name" type="text" class="form-control">
          </div>
        </div>
        <!-- Type -->
        <div class="row mb-1 margin-down-15">
          <div class="col-md-3">Xe Máy Xe Hơi</div>
          <div class="col-md-6">
            <b-form-select
              :options="vehicle_types"
              v-model="vehicle.vehicle_type"
              class="form-control"
            />
          </div>
        </div>
        <!-- Plate -->
        <div class="row mb-1 margin-down-15">
          <div class="col-md-3">Biển Số</div>
          <div class="col-md-6">
            <input v-model="vehicle.plate" type="text" class="form-control">
          </div>
        </div>
        <!-- Branch -->
        <div class="row mb-1 margin-down-15">
          <div class="col-md-3">Nhãn Hiệu</div>
          <div class="col-md-6">
            <input v-model="vehicle.branch" type="text" class="form-control">
          </div>
        </div>
        <!-- Color -->
        <div class="row mb-1 margin-down-15">
          <div class="col-md-3">Màu Sắc</div>
          <div class="col-md-6">
            <input v-model="vehicle.color" type="text" class="form-control">
          </div>
        </div>
        <!-- isDriver -->
        <!-- <div class="row mb-1 margin-down-15">
          <div class="col-md-3">Là Tài Xế</div>
          <div class="col-md-6">
            <div class="form-group">
              <div class="radio custom-control-inline" v-for="(option, index) in isDriverOptions" :key="index">
                <label>
                  <input type="radio" name="isDriverOptions" :value="option.value" checked=""  v-model="vehicle.isDriver">
                  {{option.text}}
                </label>
              </div>
            </div>
          </div>
        </div> -->
        <!-- Original Card -->
        <div class="row mb-1 margin-down-15">
          <div class="col-md-3">Mã Thẻ Lần Đầu</div>
          <div class="col-md-6">
            <input v-model="vehicle.original_card" type="text" class="form-control">
          </div>
        </div>
        <!-- Deactivate Card Date -->
        <div class="row mb-1 margin-down-15">
          <div class="col-md-3">Ngày Hủy Thẻ</div>
          <div class="col-md-6">
            <div class="input-group date">
              <div class="input-group-addon">
                <i class="fa fa-calendar"></i>
              </div>
              <date-picker v-model="vehicle.deactivate_card_date" :config="options"/>
            </div>
          </div>
        </div>
        <!-- Reactivate Card Date -->
        <div class="row mb-1 margin-down-15">
          <div class="col-md-3">Ngày Cấp Lại Thẻ</div>
          <div class="col-md-6">
            <div class="input-group date">
              <div class="input-group-addon">
                <i class="fa fa-calendar"></i>
              </div>
              <date-picker v-model="vehicle.reactivate_card_date" :config="options"/>
            </div>
          </div>
        </div>
        <!-- Issued Staff -->
        <div class="row mb-1 margin-down-15">
          <div class="col-md-3">Nhân Viên PT</div>
          <div class="col-md-6">
            <b-form-select
              :options="staffs"
              v-model="vehicle.issue_staff"
              class="form-control"
            />
          </div>
        </div>
        <!-- Applied Fee -->
        <div class="row mb-1 margin-down-15">
          <div class="col-md-3">Phí Áp Dụng</div>
          <div class="col-md-6">
            <b-form-select
              :options="services"
              v-model="vehicle.applied_service"
              class="form-control"
            />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-default pull-left"
          data-dismiss="modal"
        >{{$t('common.cancel')}}</button>
        <button
          type="button"
          class="btn btn-primary"
          v-if="!!id"
          @click="onSave"
        >{{$t('common.save')}}</button>
        <button
          type="button"
          class="btn btn-primary"
          v-else
          @click="onAdd"
        >{{$t('common.add')}}</button>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import datePicker from "vue-bootstrap-datetimepicker"
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css"
import utils from '@/lib/utils'

export default {
  name: "VehicleInput",
  props: {
    id: {
      type: Number,
      default: () => { return 0 }
    },
  },
  data() {
    return {
      apartments: [],
      customers: [],
      staffs: [],
      services: [],
      //vehicle_types: [],
      vehicle: {
        apartment: null,
        vehicle_owner: null,
        vehicle_registration_name: null,
        vehicle_type: null,
        plate: null,
        branch: null,
        color: null,
        isDriver: false,
        original_card: null,
        deactivate_card_date: null,
        reactivate_card_date: null,
        issue_staff: null,
        applied_service: null
      },
      options: {
        format: "YYYY-MM-DD"
      },
      isDriverOptions: [
        { text: 'Yes', value: true },
        { text: 'No', value: false }
      ],
      apartment_vehicle_services: []
    }
  },
  watch: {
    id: function() {
      if (this.id !== 0) {
        this.GET_VEHICLE_DETAIL({id: this.id}).then(
          function(res) {
            let vehicle_data = res.data
            this.vehicle.apartment = vehicle_data.apartment
            this.vehicle.vehicle_owner = vehicle_data.vehicle_owner
            this.vehicle_registration_name = vehicle_data.vehicle_registration_name
            this.vehicle_type = vehicle_data.vehicle_type
            this.vehicle.plate = vehicle_data.plate
            this.vehicle.branch = vehicle_data.branch
            this.vehicle.color = vehicle_data.color
            this.vehicle.isDriver = vehicle_data.isDriver
            this.vehicle.original_card = vehicle_data.original_card
            this.vehicle.deactivate_card_date = vehicle_data.deactivate_card_date
            this.vehicle.reactivate_card_date = vehicle_data.reactivate_card_date
            this.vehicle.issue_staff = vehicle_data.issue_staff
            this.vehicle.applied_service = vehicle_data.applied_service
            this.onSelectDefaultOptions()
          }.bind(this)
        )
      } else {
        this.reset()
      }
    },
    APARTMENT_DETAIL_DATA: function() {
      let apartment_vehicle_services_data = this.APARTMENT_DETAIL_DATA.apartmentservices
      let apartment_vehicle_services = []
      apartment_vehicle_services_data.forEach(service => {
        if (service.service_details.servicetype === 3) {
          let item = {
            id: service.service_details.id,
            fee_value: service.service_details.fee_value,
            name: service.service_details.name
          }
          apartment_vehicle_services.push(item)
        }
      })
      this.apartment_vehicle_services = apartment_vehicle_services
    }
  },
  computed: {
    ...mapGetters([
      "APARTMENT_DETAIL_DATA",
      "VEHICLE_TYPE_LIST"
    ]),
    vehicle_types: function() {
      let result_list = [{ value: null, text: "---" }]
      this.VEHICLE_TYPE_LIST.forEach(v => {
        let item = {
          value: v.id,
          text: v.name
        }
        result_list.push(item)
      })
      return result_list
    }
  },
  methods: {
    ...mapActions([
      "GET_APARTMENT_LIST",
      "GET_CUSTOMER_LIST",
      "GET_SERVICE_LIST_NO_PAGE",
      "GET_VEHICLE_DETAIL",
      "GET_APARTMENT_DETAIL",
      "GET_RESIDENT_LIST",
      "GET_STAFF_LIST",
      // "GET_VEHICLE_TYPE_LIST"
    ]),
    reset: function() {
      this.vehicle = {
        apartment: null,
        vehicle_owner: null,
        vehicle_registration_name: null,
        vehicle_type: null,
        plate: null,
        branch: null,
        color: null,
        isDriver: false,
        original_card: null,
        deactivate_card_date: null,
        reactivate_card_date: null,
        issue_staff: null,
        applied_service: null
      }
      this.apartment_vehicle_services = []
    },
    onAdd: function() {
      const saveVehicle = {
        apartment: this.vehicle.apartment,
        vehicle_owner: this.vehicle.vehicle_owner,
        vehicle_registration_name: this.vehicle.vehicle_registration_name,
        vehicle_type: this.vehicle.vehicle_type,
        plate: this.vehicle.plate,
        branch: this.vehicle.branch,
        color: this.vehicle.color,
        isDriver: this.vehicle.isDriver,
        original_card: this.vehicle.original_card,
        deactivate_card_date: utils.formatSqlDate(this.vehicle.deactivate_card_date, null, 'YYYY-MM-DDThh:mm'),
        reactivate_card_date: utils.formatSqlDate(this.vehicle.reactivate_card_date, null, 'YYYY-MM-DDThh:mm'),
        issue_staff: this.vehicle.issue_staff,
        applied_service: this.vehicle.applied_service
      }
      this.$emit("vehicle-add", saveVehicle);
    },
    onSave: function() {
      const id = this.id
      const saveVehicle = {
        apartment: this.vehicle.apartment,
        vehicle_owner: this.vehicle.vehicle_owner,
        vehicle_registration_name: this.vehicle.vehicle_registration_name,
        vehicle_type: this.vehicle.vehicle_type,
        plate: this.vehicle.plate,
        branch: this.vehicle.branch,
        color: this.vehicle.color,
        isDriver: this.vehicle.isDriver,
        original_card: this.vehicle.original_card,
        deactivate_card_date: utils.formatSqlDate(this.vehicle.deactivate_card_date, null, 'YYYY-MM-DDThh:mm'),
        reactivate_card_date: utils.formatSqlDate(this.vehicle.reactivate_card_date, null, 'YYYY-MM-DDThh:mm'),
        issue_staff: this.vehicle.issue_staff,
        applied_service: this.vehicle.applied_service
      }
      this.$emit("vehicle-save", id, saveVehicle);
    },
    onChangeApartment: function() {
      this.onSelectDefaultOptions()
    },
    onSelectDefaultOptions: function() {
      if (!this.vehicle.apartment) {
        this.vehicle.applied_service = null
        this.vehicle.vehicle_owner = null
      } else {
        const data = { id: this.vehicle.apartment }
        this.GET_APARTMENT_DETAIL(data).then(
          function(res) {
            this.selectDefaultService(res.apartmentservices)
          }.bind(this)
        )
        this.getResidents(this.vehicle.apartment)
      }
    },
    selectDefaultService: function(services) {
      let found_vehicle_service = false
      for (let i=0; i < services.length; i++) {
        let service = services[i]
        if (service.service_details.servicetype === 3) {
          this.vehicle.applied_service = service.service_details.id
          found_vehicle_service = true
          break
        }
      }
      if (!found_vehicle_service) {
        this.vehicle.applied_service = null
      }
    },
    selectDefaultOwner: function(residents) {
      let found_owner = false
      for (let i=0; i < residents.length; i++) {
        let resident = residents[i]
        if (resident.isOwner) {
          this.vehicle.vehicle_owner = resident.resident.id
          found_owner = true
          break
        }
      }
      if (!found_owner) {
        this.bicycle.vehicle_owner = null
      }
    },
    getResidents(apartment_id) {
      const apartmentdata = {
        params: {
          apartment: apartment_id
        }
      }
      this.GET_RESIDENT_LIST(apartmentdata).then(
        function(res) {
          this.selectDefaultOwner(res.data)
        }.bind(this)
      )
    },
  },
  components: {
    "date-picker": datePicker,
  },
  mounted() {
    this.GET_APARTMENT_LIST().then(
      function(res) {
        let result = res.data
        let apartments = [
          {
            value: null,
            text: "---"
          }
        ]
        result.forEach(apartment => {
          let item = {
            value: apartment.id,
            text: apartment.apartment_code
          }
          apartments.push(item)
        })
        this.apartments = apartments
      }.bind(this)
    )
    this.GET_CUSTOMER_LIST().then(
      function(res) {
        let customerList = res.data;
        let customers = [{ value: null, text: "---" }];
        customerList.forEach(data => {
          let full_name = `${data.last_name} ${data.first_name}`;
          let item = {
            value: data.id,
            text: full_name
          };
          customers.push(item);
        });
        this.customers = customers;
      }.bind(this)
    )
    this.GET_SERVICE_LIST_NO_PAGE({feegroup: 1}).then(
      function(res) {
        let result = res.data
        let services = [
          {
            value: null,
            text: "---"
          }
        ]
        result.forEach( service => {
          let value = service.id
          let text = service.name
          let item = {
            value: value,
            text: text
          }
          if (service.service_type === 3) {
            services.push(item)
          }
        })
        this.services = services
      }.bind(this)
    )
    this.GET_STAFF_LIST().then(
      function(res) {
        let staffList = res.data;
        let staffs = [{ value: null, text: "---" }];
        staffList.forEach(data => {
          let full_name = `${data.last_name} ${data.first_name}`;
          let item = {
            value: data.id,
            text: full_name
          };
          staffs.push(item);
        });
        this.staffs = staffs;
      }.bind(this)
    )
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.margin-down-15 {
  margin-bottom: 15px;
}

.row {
  margin-right: 0px;
  margin-left: 0px;
}

.lead {
  font-size: 16px;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

</style>


// WEBPACK FOOTER //
// src/views/Apartment/VehicleInput.vue